import React, { useState } from "react";
import {
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import { ref, get, query, orderByChild, equalTo } from "firebase/database";
import { auth, database } from "../firebase";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaGoogle } from "react-icons/fa";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!email || !password) {
      toast.error("Please fill in email and password fields.");
      return;
    }

    setIsLoading(true);

    try {
      const usersQuery = query(
        ref(database, "users"),
        orderByChild("email"),
        equalTo(email)
      );
      debugger;
      const snapshot = await get(usersQuery);
      if (snapshot.exists()) {
        const users = snapshot.val();
        const user = Object.values(users)[0]; // Get the first user found
        if (user.email !== email) {
          toast.error("Invalid email and password.");
          return;
        }
        if (user.isActive === true) {
          await signIn(); // Active user, proceed with login
        } else {
          toast.error(
            "Invalid email and password. Please Contact Support Team."
          );
        }
      } else {
        toast.error("User not found in the database.");
      }
    } catch (error) {
      toast.error("Error fetching user data.");
      console.error("Error during fetching user data:", error);
    }

    setIsLoading(false);
  };

  const signIn = async () => {
    try {
      // Attempt to sign in with email and password
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // Check if user exists in the database
      const userRef = ref(database, `users/${user.uid}`);
      const snapshot = await get(userRef);
      if (snapshot.exists()) {
        const { role } = snapshot.val();
        // Navigate based on user role
        if (role === "Admin") {
          navigate("/dashboard");
        } else if (role === "User") {
          navigate("/profile");
        } else {
          toast.error("Role not recognized.");
        }
        toast.success("Login successful!");
      } else {
        toast.error("Invalid email and password.");
      }
    } catch (signInError) {
      if (
        signInError.code === "auth/user-not-found" ||
        signInError.code === "auth/wrong-password"
      ) {
        // If user not found or wrong password, call signUp
        toast.error("Invalid email or password.");
        console.error("Error during sign-in:", signInError);
      } else {
        toast.error("Invalid email or password.");
        console.error("Error during sign-in:", signInError);
      }
    }
  };
  // Google login handler
  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Check if the user exists in the database
      const userRef = ref(database, `users/${user.uid}`);
      const snapshot = await get(userRef);

      if (snapshot.exists()) {
        const { role } = snapshot.val();
        if (role === "Admin") {
          navigate("/dashboard");
        } else if (role === "User") {
          navigate("/profile");
        } else {
          toast.error("Role not recognized.");
        }
        toast.success("Login successful!");
      } else {
        toast.error("User not found in the database.");
      }
    } catch (error) {
      toast.error("Google login failed.");
      console.error("Error during Google login:", error);
    }
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="max-w-sm w-full p-6 bg-white rounded-lg">
        <h2 className="text-2xl font-semibold text-center mb-4">Login</h2>
        <div className="mb-4">
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700"
          >
            Email
          </label>
          <input
            id="email"
            type="email"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleLogin();
            }}
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="password"
            className="block text-sm font-medium text-gray-700"
          >
            Password
          </label>
          <input
            id="password"
            type="password"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleLogin();
            }}
          />
        </div>
        <button
          onClick={handleLogin}
          className="w-full bg-blue-500 text-white py-2 rounded-lg mt-4 hover:bg-blue-600 disabled:opacity-50"
          disabled={isLoading}
        >
          {isLoading ? "Logging in..." : "Login"}
        </button>
        <div className="mt-4 text-center">
          <span>OR</span>
        </div>
        <div className="mt-4 text-center">
          <button
            onClick={handleGoogleLogin}
            className="w-full bg-red-500 text-white py-2 rounded-lg hover:bg-red-600 flex items-center justify-center gap-2"
          >
            <FaGoogle />
            Login with Google
          </button>
        </div>

        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
            Don't have an account?&nbsp;
            <span
              onClick={() => navigate("/signup")}
              className="text-blue-500 hover:underline cursor-pointer"
            >
              Sign Up
            </span>
          </p>
          <p className="text-sm text-gray-600 mt-2">
            <span
              onClick={() => navigate("/forgot-password")}
              className="text-blue-500 hover:underline cursor-pointer"
            >
              Forgot Password?
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
